import constants from '@repo/sharedlib/src/utils/constants';
import imageUrlBuilder from '@sanity/image-url';
import type { Image } from '@sanity/types';

const builder = imageUrlBuilder({
	baseUrl: 'https://sanity-cdn.retainapp.ai/',
	projectId: constants.SANITY_API_PROJECT_ID,
	dataset: constants.SANITY_API_DATASET
});

export function urlFor(source: Image) {
	return builder.image(source);
}
